import './dismiss';



// WEBPACK FOOTER //
// ./client/src/core/components/alert-bar/index.js